import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'

/**
 * Modal for confirming the payout submission.
 */
export class ConfirmSubmitModalViewModel extends ModalViewModel {
  /**
   * Constructor.
   */
  constructor(
    private readonly onConfirm: () => unknown,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  /**
   * Confirm that we wish to pay out.
   */
  confirm = () => {
    this.onConfirm()
    this.close()
  }
}
